import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CalAngularModule } from '@cvx/cal-angular';

import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';
import { requestNotificationInterceptor } from './interceptors/request-notification.interceptor';
import { environment } from '../environments/environment';

function isAzureWebsitesHost(hostname: string): boolean {
  return hostname === 'azurewebsites.net' || hostname.endsWith('.azurewebsites.net');
}

function getCalConfig(): any {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;

  // Determine redirect URI based on environment
  let redirectUri: string;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    redirectUri = `${protocol}//localhost:4200`;
  } else if (isAzureWebsitesHost(hostname)) {
    redirectUri = `${protocol}//${hostname}/`;
  } else {
    redirectUri = `${protocol}//${hostname}`;
  }

  return {
    autoSignIn: true,
    popupForLogin: false,
    cacheLocation: 'localStorage',
    instance: 'https://login.microsoftonline.com/',
    tenantId: environment.auth.tenantId,
    clientId: environment.auth.clientId,
    redirectUri: redirectUri,
    oidcScopes: ['openid', 'profile', 'offline_access', 'User.Read'],
    graphScopes: ['User.Read', 'User.Read.All'],
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, requestNotificationInterceptor])),
    importProvidersFrom(
      BrowserModule,
      RouterModule,
      CalAngularModule.forRoot(getCalConfig()),
    ),
  ],
};
